import { mapErknmPlanStatusByStatusTitle } from 'APIPackage/PlanListModule/constants/mapErknmPlanStatusByStatusTitle';
import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';

export const getPlanErknmStatusTitleByStatus = (status: ErknmPlanStatusesEnum | null | undefined): string | undefined =>
  Object.keys(mapErknmPlanStatusByStatusTitle).find(
    (key: keyof typeof mapErknmPlanStatusByStatusTitle) => mapErknmPlanStatusByStatusTitle[key] === status,
  );
